import { io } from 'socket.io-client';

const api_base_url = process.env.REACT_APP_API_URL;

const agent_id = localStorage.getItem('agent_id');

export const socket = io(api_base_url, {autoConnect: false, query: 'agentId=' + agent_id});